import React from 'react';

export enum DesignerMetaLayouts {
    tabular,
    compact,
}

export interface DesignerMetaContext {
    layout: DesignerMetaLayouts;

    /* TODO: Remove this showResponsiveness prop once Prezi designers have better scores */
    hasResponsiveness?: boolean;
    hasMoreResultsUrl?: boolean;
}

export default React.createContext<DesignerMetaContext>({
    layout: DesignerMetaLayouts.tabular,
    hasMoreResultsUrl: true,
    hasResponsiveness: true,
});
